import React from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import "./styles.css"
import withDrawer from "../../components/withDrawer"
import MenuIcon from "@material-ui/icons/Menu"
import {
  Button,
  Typography,
  Card,
  CardContent,
  CardActions,
  Input,
  InputLabel,
  FormControl,
  Dialog
} from "@material-ui/core"
import Horizontal_Logo from "../../assets/images/sselogo1(nobackwhite).png"
import MoreVert from "@material-ui/icons/MoreVert"
import PhotoCamera from "@material-ui/icons/PhotoCamera"
import IdIcon from "../../assets/images/id_icon.svg"
import { Image, Transformation, CloudinaryContext } from "cloudinary-react"
import { uploadImage, sendPhotoID } from "../../actions/avatarImage"
import CircularProgress from "@material-ui/core/CircularProgress"
// import AccountIcon from '@material-ui/icons/AccountCircle'
import {
  checkUserByPhone,
  createUser
  // confirmUser,
  // ocrUpload
} from "../../actions/users"
import MyMapComponent from "../../components/MyMapComponent"
import {
  getAddress,
  getLatLng // addShowingAttendee
} from "../../actions/users"
import { TextMaskCustom } from "../../components/MaskedInput"
import $ from "jquery"
import {
  updateEvent,
  startEvent,
  deleteEvent,
  resetEvent
} from "../../actions/events"
import { doRefresh } from "../../actions/authentication"
import { openSnackBar } from "../../actions/snack-bar"
import mapImage from "../../assets/images/location_not_found.jpg"

const google = window.google

const mapsStaticURL = "https://maps.googleapis.com/maps/api/staticmap?"

class ShowingsDetail extends React.Component {
  state = {
    clientData: {
      phone: "",
      first_name: "",
      last_name: "",
      title: "",
      address: "",
      id: "",
      hasLicense: null,
      photo_id: ""
    },
    address: "",
    addressParts: {},
    lat: "",
    lng: "",
    zoom: 13,
    size: "400x200",
    foundClientUser: null,
    timeout: false,
    isPhotoInState: false,
    pendingLicenseRecheck: false,
    spin: false,
    showClientData: false,
    showModal: false,
    spinConfirm: false,
    spinState: true
  }

  onDrop = file => {
    this.setState({ spin: true })
    this.props.dispatch(
      uploadImage(file.target.files[0], "licensePhoto", this.setLicenseToState)
    )
  }

  onDropAddLicense = () => {
    this.sendLicenseToDatabase()
  }

  setLicenseToState = stringifiedPhotoData => {
    let newData = this.state.clientData
    newData.photo_id = stringifiedPhotoData.photo_id

    this.setState({
      clientData: newData,
      isPhotoInState: true,
      spin: false
    })
  }

  sendLicenseToDatabase() {
    this.props.dispatch(
      sendPhotoID(this.state.clientData.photo_id, this.state.clientData.id)
    )
  }

  componentDidMount() {
    let autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      {
        types: ["geocode"]
      }
    )

    // grab current location coords and best guess address
    this.geolocate()

    autocomplete.addListener("place_changed", () => {
      this.setState({ address: $("#autocomplete").val() })
      let place = autocomplete.getPlace()
      let location =
        place.geometry && place.geometry.location
          ? place.geometry.location
          : null

      let latitude = location ? location.lat() : null
      let longitude = location ? location.lng() : null
      if (latitude == null || longitude == null) {
        return false
      } else {
        this.props.dispatch(
          getLatLng(place.formatted_address, this.handleOnChange, true)
        )
      }
    })
  }

  geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.props.dispatch(
            // Get Address based off of coords.
            getAddress(
              position.coords.latitude,
              position.coords.longitude,
              this.handleOnLoad // ! handleOnLoad
            )
          )
          // then set coords to state.
          let zoomScale = 13
          this.setState({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            mapURL: `${mapsStaticURL}center=${position.coords.latitude},${
              position.coords.longitude
            }&zoom=${zoomScale}&size=${this.state.size}`
          })
        },
        err =>
          this.props.dispatch(
            openSnackBar({ message: "Could not find location" })
          )
      )
    }
  }

  handleOnLoad = (e, formattedAddress, obj) => {
    this.setState({
      address: formattedAddress,
      addressParts: { ...obj }
    })
  }

  handleInput = e => {
    if (this.state.timeout) {
      clearTimeout(this.state.timeout)
    }
    e.persist()
    const timeout = setTimeout(() => {
      this.props.dispatch(getLatLng(e.target.value, this.handleOnChange))
    }, 500)
    this.setState({
      address: e.target.value,
      timeout
    })
  }

  handleOnChange = (e, formattedAddress, obj) => {
    if (obj) {
      if (e) {
        this.setState({
          address: formattedAddress,
          addressParts: { ...obj },
          lat: obj.lat,
          lng: obj.lng
        })
      } else {
        this.setState({
          lat: obj.lat,
          lng: obj.lng
        })
      }
    }
  }

  handleCancelEvent = () => {
    this.props.dispatch(deleteEvent(this.props.match.params.id))
    // this.props.dispatch(endEvent(this.props.match.params.id))
    this.props.history.push("/showings")
  }

  handleCreateUser = () => {
    this.props
      .dispatch(createUser(this.state.clientData))
      .then(res => {
        const newClientData = this.state.clientData
        newClientData.id = res.id

        this.setState({
          clientData: newClientData,
          foundClientUser: true,
          pendingLicenseRecheck: true
        })
      })
      .then(() => {
        this.props.dispatch(doRefresh()).then(() => {
          this.handleStart()
        })
      })
  }

  handleStart = () => {
    if (this.state.addressParts && this.state.addressParts.city) {
      this.setState({ spinStart: true })
      this.props
        .dispatch(
          updateEvent(
            this.state.addressParts,
            this.state.clientData.id,
            this.props.match.params.id,
            this.state.lat,
            this.state.lng
          )
        )
        .then(() => {
          this.props
            .dispatch(startEvent(this.props.match.params.id))
            .then(() => {
              const { clientData } = this.state
              this.props
                .dispatch(
                  resetEvent(
                    this.props.match,
                    this.state.interval,
                    clientData ? clientData : null
                  )
                )
                .then(() => {
                  this.setState({ spinStart: false })
                  this.props.history.push(
                    `/showings/timer/${Number(this.props.match.params.id)}`
                  )
                })
            })
        })
      if (this.state.isPhotoInState) {
        this.sendLicenseToDatabase()
      }
    } else {
      this.props.dispatch(openSnackBar({ message: "No address chosen" }))
    }
    // this.props.history.push(`/showings/timer/${this.props.match.params.id}`)
  }

  startWithoutAttendee = () => {
    if (this.state.addressParts && this.state.addressParts.city) {
      this.setState({ spinConfirm: true })
      this.props
        .dispatch(
          updateEvent(
            this.state.addressParts,
            null,
            this.props.match.params.id,
            this.state.lat,
            this.state.lng
          )
        )
        .then(() => {
          this.props
            .dispatch(startEvent(this.props.match.params.id))
            .then(() => {
              this.setState({ spinConfirm: false })
              this.props.history.push({
                pathname: `/showings/timer/${Number(this.props.match.params.id)}`,
                state: this.props.location.state
              })
            })
            .catch(err => console.log(err))
        })
    } else {
      this.props.dispatch(openSnackBar({ message: "No address chosen" }))
    }
  }

  confirmClient = e => {
    let newData = this.state.clientData
    newData.phone = e.target.value
    this.setState({ clientData: newData })
    // Once number has req length check if in db, and set indicator toggles
    if (newData.phone.length >= 14) {
      this.props
        .dispatch(checkUserByPhone(newData.phone.replace(/\D/g, "")))
        .then(res => {
          let newData = this.state.clientData
          newData.first_name = res.first_name
          newData.last_name = res.last_name
          newData.id = res.id
          newData.hasLicense = Boolean(res.has_license)
          // console.log('checked', newData)
          this.setState({
            clientData: newData,
            foundClientUser: true
          })
        })
        .catch(err => {
          if (err.response.body.message === "user does not exist") {
            let newData = this.state.clientData
            newData.hasLicense = false
            this.setState({
              foundClientUser: false,
              clientData: newData
            })
          }
        })
    }

    // Clear indicator toggles to null in lieu of false or true
    if (newData.phone.length < 14) {
      newData.first_name = ""
      newData.last_name = ""
      newData.id = ""
      newData.hasLicense = null // ! CHANGE TODO WHEN CALL IS READY
      this.setState({
        clientData: newData,
        foundClientUser: null
      })
    }
  }

  render() {
    const { toggleDrawer } = this.props
    const { clientData } = this.state
    let { photo_id } = clientData

    const photoID =
      typeof photo_id === "string" &&
      photo_id.length > 0 &&
      JSON.parse(photo_id) &&
      JSON.parse(photo_id).public_id
        ? JSON.parse(photo_id).public_id
        : ""

    console.log(this.state)

    return (
      <div className="showings-detail-app">
        <div className="showings-detail-header">
          <MenuIcon
            // style={{ visibility: 'hidden' }}
            className="showings-detail-menu"
            onClick={() => toggleDrawer()}
          />
          <img
            src={Horizontal_Logo}
            className="showings-detail-logo"
            alt="logo"
          />
          <MoreVert
            // style={{ visibility: 'hidden' }}
            className="showings-detail-menu"
            alt="MoreVert"
            style={{ visibility: "hidden" }}
          />
        </div>

        <div style={{ overflow: "scroll" }}>
          <div className="showings-detail-license">
            {/* CARDS MAP AND CONTACT DETAILS */}

            <div className="showings-detail-cards">
              <Card className="map-cardWrapper">
                <div
                  className="map-headerBox"
                  style={{
                    minWidth: "90vw",
                    minHeight: "100px"
                  }}
                >
                  {this.state.lat && this.state.lng ? (
                    <MyMapComponent
                      isMarkerShown
                      lat={this.state.lat}
                      lng={this.state.lng}
                      zoom={13}
                    />
                  ) : (
                    <img
                      style={{
                        height: "100px",
                        width: "90vw",
                        objectFit: "cover"
                      }}
                      src={mapImage}
                    />
                  )}
                </div>

                <CardActions className="map-footerBox">
                  <div className="map-footerBox">
                    <FormControl fullWidth>
                      <InputLabel htmlFor="currentLocation">Address</InputLabel>
                      <Input
                        type="text"
                        name="currentLocation"
                        id="autocomplete"
                        value={this.state.address}
                        onChange={e => this.handleInput(e)}
                        fullWidth
                      />
                    </FormControl>
                  </div>
                </CardActions>
              </Card>
              {!this.state.showClientData ? (
                <Card className="client-card-app">
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly"
                      }}
                    >
                      <Button color="primary" onClick={this.handleCancelEvent}>
                        CANCEL
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={this.state.spinConfirm}
                        onClick={() => this.startWithoutAttendee()}
                      >
                        {this.state.spinConfirm ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Confirm Address"
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ) : null}
              {/* <Dialog
                open={this.state.showModal}
                onClose={() => this.setState({ showModal: false })}
              >
                <Card>
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      <Button
                        variant="text"
                        color="primary"
                        disabled={
                          this.state.clientData.phone.length !== 0 ||
                          this.state.clientData.first_name.length !== 0 ||
                          this.state.clientData.last_name.length !== 0
                        }
                        onClick={() => this.startWithoutAttendee()}
                      >
                        {this.state.spinConfirm ? (
                          <CircularProgress size={24} />
                        ) : (
                          "without client"
                        )}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          this.setState({
                            showModal: false,
                            showClientData: true
                          })
                        }
                      >
                        With Client
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Dialog> */}
              {/* {this.state.showClientData ? (
                <Card className="client-card-app">
                  <div className="client-card-body">
                    <form
                      className="client-card-form"
                      id="register-form"
                      noValidate
                      autoComplete="off"
                    >
                      <FormControl fullWidth>
                        <InputLabel htmlFor="loginPhone">
                          Client Phone
                        </InputLabel>
                        <Input
                          type="tel"
                          name="loginPhone"
                          id="loginPhone"
                          value={this.state.clientData.phone}
                          inputComponent={TextMaskCustom}
                          onChange={this.confirmClient}
                        />
                      </FormControl>

                      <div className="client-card-names-wrapper">
                        <FormControl
                          style={{
                            margin: "10px 20px 0px 0px"
                          }}
                        >
                          <InputLabel htmlFor="registerFirstName">
                            First Name
                          </InputLabel>
                          <Input
                            type="text"
                            inputProps={{ required: true }}
                            name="registerFirstName"
                            value={this.state.clientData.first_name}
                            onChange={e => {
                              let newData = clientData
                              newData.first_name = e.target.value
                              this.setState({ clientData: newData })
                            }}
                            id="registerFirstName"
                            autoComplete="nope"
                            disabled={this.state.foundClientUser}
                          />
                        </FormControl>

                        <FormControl
                          style={{
                            margin: "10px 0px 0px 0px"
                          }}
                        >
                          <InputLabel htmlFor="registerLastName">
                            Last Name
                          </InputLabel>
                          <Input
                            type="text"
                            inputProps={{ required: true }}
                            name="registerLastName"
                            value={this.state.clientData.last_name}
                            onChange={e => {
                              let newData = clientData
                              newData.last_name = e.target.value
                              this.setState({ clientData: newData })
                            }}
                            id="registerLastName"
                            autoComplete="nope"
                            disabled={this.state.foundClientUser}
                          />
                        </FormControl>
                      </div>
                    </form>
                  </div>

                  
                  <div className="client-card-actions">
                    <Button color="primary" onClick={this.handleCancelEvent}>
                      CANCEL
                    </Button>

                    {this.state.foundClientUser ? (
                      <Button
                        variant="contained"
                        className="client-card-footerButton"
                        color="primary"
                        onClick={() => this.handleStart()}
                        disabled={
                          !(
                            this.state.clientData.phone.length >= 14 &&
                            ((Boolean(
                              this.props.authentication.authenticatedUser
                                .license_required
                            ) === true
                              ? photoID !== ""
                              : true) ||
                              (this.state.clientData &&
                                this.state.clientData.hasLicense))
                          ) || this.state.spinStart
                        }
                      >
                        {this.state.spinStart ? (
                          <CircularProgress size={24} />
                        ) : (
                          "START"
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        className="client-card-footerButton"
                        color="primary"
                        onClick={() => this.handleCreateUser()}
                        disabled={
                          !(
                            this.state.clientData.phone.length >= 14 &&
                            (Boolean(
                              this.props.authentication.authenticatedUser
                                .license_required
                            ) === true
                              ? photoID !== ""
                              : true) &&
                            (this.state.clientData &&
                              this.state.clientData.first_name &&
                              this.state.clientData.last_name)
                          )
                        }
                      >
                        START
                      </Button>
                    )}
                  </div>
                </Card>
              ) : null} */}
            </div>

            {/* INDICATOR BUTTONS*/}

            {!this.state.foundClientUser ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around"
                }}
              >
                {/* FOUND USER HAS LICENSE? */}

                {this.state.clientData.photo_id.length > 0 ? null : (
                  <div className="showings-detail-actions">
                    {this.state.spin ? (
                      <CircularProgress />
                    ) : (
                      <div
                        style={{
                          visibility: !(
                            this.state.clientData.phone.length >= 14 &&
                            (this.state.clientData &&
                              this.state.clientData.first_name &&
                              this.state.clientData.last_name)
                          )
                            ? "hidden"
                            : "unset"
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            document.getElementById("file-upload").click()
                          }}
                          style={{
                            transform: "scale(1.2)"
                          }}
                        >
                          ADD LICENSE
                          {/* <img src={IdIcon} alt="Id Icon" className="id-icon" /> */}
                        </Button>

                        {/* <Typography
                          style={{
                            padding: '10px',
                            color: '#000'
                          }}
                        >
                          ADD LICENSE
                        </Typography> */}

                        <input
                          type="file"
                          onChange={e => this.onDrop(e, "upload-photo-button")}
                          style={{
                            display: "none"
                          }}
                          id="file-upload"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around"
                }}
              >
                {/* USER NOT FOUND */}
                {this.state.clientData.hasLicense ? (
                  <div>
                    {this.state.clientData.hasLicense ? (
                      <div className="showings-detail-actions">
                        <div>
                          <Button
                            variant="fab"
                            style={{ backgroundColor: "#00ff00" }}
                            //  onClick={() => {
                            //    document.getElementById('file-upload').click()
                            //  }}
                          >
                            <img
                              src={IdIcon}
                              alt="Id Icon"
                              className="id-icon"
                            />
                          </Button>
                          <Typography
                            style={{
                              padding: "10px",
                              color: "#000"
                            }}
                          >
                            LICENSE FOUND
                          </Typography>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div>
                    {!this.state.isPhotoInState ? (
                      <div className="showings-detail-actions">
                        <Button
                          variant="fab"
                          color="primary"
                          disabled={!(this.state.clientData.phone.length >= 14)}
                          onClick={() => {
                            document.getElementById("file-upload").click()
                          }}
                        >
                          <img src={IdIcon} alt="Id Icon" className="id-icon" />
                        </Button>

                        <input
                          type="file"
                          onChange={e => this.onDrop(e, "upload-photo-button")}
                          style={{
                            opacity: 0,
                            padding: "10px",
                            display: "none"
                          }}
                          id="file-upload"
                        />

                        <Typography
                          style={{
                            padding: "10px",
                            color: "#888"
                          }}
                        >
                          ADD LICENSE
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            )}
            {photoID && (
              <div>
                <CloudinaryContext
                  cloudName="safeshowings"
                  style={{ position: "relative", minHeight: "224px" }}
                >
                  <Button
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      right: "20px"
                    }}
                    variant="fab"
                    color="primary"
                    onClick={() => {
                      document.getElementById("file-upload").click()
                    }}
                  >
                    <PhotoCamera />
                  </Button>
                  <input
                    type="file"
                    onChange={e => this.onDrop(e, "upload-photo-button")}
                    style={{
                      opacity: 0,
                      padding: "10px",
                      display: "none"
                    }}
                    id="file-upload"
                  />

                  <Image publicId={photoID} format="png">
                    <Transformation
                      crop="fill"
                      gravity="faces"
                      // width="345"
                      width={`${Math.round(
                        window.innerWidth - window.innerWidth * 0.1
                      )}`}
                      height="220"
                    />
                  </Image>
                </CloudinaryContext>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  // console.log(state)
  return {
    authentication: state.authentication,
    profile: state.profile,
    pics: state.pics,
    toggle: state.toggle,
    images: state.images
  }
}
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: "DRAWER_TOGGLED", payload: true }),
    dispatch
  }
}

export default withDrawer(
  compose(
    connect(
      mapStateToProps,
      mapActionsToProps
    )
  )(ShowingsDetail)
)
